import {getColor} from "@/styles/ThemeConfig";
import Image from "next/image";
import styled from "@emotion/styled";
import Link from "next/link";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";


const BlogCardWrapper = styled.div`
    margin:10px;
    cursor: pointer;
    position: relative;

    width:370px;

    .main_image{
        width:370px;
        height:370px;
        object-fit:cover;
    }
    @media only screen and (${breakpoints.mobile}) {
        width:270px;
        .main_image{
            width:270px;
            height:270px;
        }
    }

    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-image: url("${props => props.$image }");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    border-bottom:1px solid ${getColor('grayBackground')};
    transition: border-width 0.3s ease-in-out, transform 0.3s ease-in-out;

    &:hover::before {
        width: 100%; /* Full width on hover */
    }

    &::before {
        content: '';
        position: absolute; /* Position the border element */
        left: 0; /* Start from the left */
        bottom: -1px; /* Align to the bottom */
        height: 2px; /* Height of the border */
        background-color: ${getColor('gold')}; /* Color of the border */
        width: 0; /* Start with 0 width */
        transition: width 0.5s ease-in-out; /* Transition effect */
    }

    .title{
        font-family: Playfair Display;
        font-size: 20px;
        color: ${getColor('green')};
        margin-bottom: 5px;
    }

    :hover{
        .title{
            color:${getColor('gold')};
        }
    }
`;

const ContentWrapper = styled.div`
    margin: 20px 0;
    min-height:130px;
    @media only screen and (${breakpoints.mobile}) {
        min-height:100px;
    }
`

export default function BlogCard({item}){
    return <ForceSSRLink style={{textDecoration:'none', all:'unset'}} href={item?.link ?? '#'}>
        <BlogCardWrapper>
            <div style={{
                position:'absolute',
                borderBottom:`2px solid ${getColor('gold')}`,
                bottom:0,
                zIndex:1,
            }}></div>

            <Image className={'main_image'} src={item?.imageUrl} alt={item?.title} width={370} height={370} />
            <div style={{
                "position": "absolute",
                "top": "20px",
                "left": "20px",
                "color": getColor('green'),
                "fontSize": "12px",
                "letterSpacing": "1.1px",
                "background": "white",
                "padding": "8px 13px",
                fontFamily:'Verdana',
            }}>
                {item?.formattedDate}
            </div>

            <ContentWrapper>
                <div
                    className={'title'}
                >
                    {item?.title}</div>
                <div style={{
                    display: 'flex',
                    alignItems:'center',
                    gap: '5px',
                    color: getColor('lightGreen'),
                }}>
                    {item?.excerpt}
                </div>
            </ContentWrapper>


        </BlogCardWrapper>
    </ForceSSRLink>
}
